import {
    ApplicationConfig,
    isDevMode,
    provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
    provideClientHydration,
    withEventReplay,
    withI18nSupport,
} from "@angular/platform-browser";
import { provideHttpClient, withNoXsrfProtection } from "@angular/common/http";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { appRoutes } from "../app.routes";
import { provideStore } from "@ngrx/store";
import { rootReducers } from "../reducers/root.reducer";
import { provideEffects } from "@ngrx/effects";
import { UserEffects } from "../effects/user.effects";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { AppEffects } from "../effects/app.effects";
import { LIGHTBOX_CONFIG, LightboxConfig } from "ng-gallery/lightbox";
import { PropertyEffects } from "../effects/property.effects";
import { provideNativeDateAdapter } from "@angular/material/core";

function provideMatDatepicker() {}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimations(),
        provideAnimationsAsync(),
        provideClientHydration(withEventReplay()),
        provideClientHydration(withI18nSupport()),
        provideHttpClient(withNoXsrfProtection()),
        provideRouter(
            appRoutes,
            withInMemoryScrolling({
                scrollPositionRestoration: "enabled",
                anchorScrolling: "enabled",
            })
        ),
        provideStore(rootReducers),
        provideEffects(UserEffects, AppEffects, PropertyEffects),
        provideStoreDevtools({
            maxAge: 25, // Retains last 25 states
            logOnly: !isDevMode(), // Restrict extension to log-only mode
            autoPause: true, // Pauses recording actions and state changes when the extension window is not open
            trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
            traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
            connectInZone: true, // If set to true, the connection is established within the Angular zone
        }),
        provideNativeDateAdapter(),
        {
            provide: LIGHTBOX_CONFIG,
            useValue: {
                keyboardShortcuts: false,
                exitAnimationTime: 1000,
            } as LightboxConfig,
        },
    ],
};
